"use client";
import { useEffect, useState } from "react";
import dino from '../../assets/img/dinon1.png'

import {
    Modal,
    Box,
    Button,
    Typography,
    Divider,
} from '@mui/material';

import brandLogo from '../../assets/img/questionaire_preference_logo.png'
import { useAuth } from '../../app/providers/auth-provider'
import { useMediaQuery } from '@mui/material';
import awsconfig from '../../awsconfig';
import { Amplify } from 'aws-amplify';

const googleIcon = "https://img.icons8.com/fluency/100/google-logo.png"

Amplify.configure(awsconfig);

export default function Login() {
    const [openLoginModal, setOpenLoginModal] = useState(true);
    const { federationLogin, user: creatorUser } = useAuth();
    const isSmallScreen = useMediaQuery('(max-width:575px)');
    const handleGoogleLogin = async () => {
        await federationLogin();
    }

    // Modal Style
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isSmallScreen?360:480,
        height: 550,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: '10px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: "linear-gradient(to top, #a18cd1 0%, #fff0fb 100%)",
        color: '#ffffff',
    };

    return <Modal
        open={openLoginModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
    >
        <Box sx={style}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img src={brandLogo?.src} alt="Brand Logo" style={{ width: 220, marginBottom: 24 }} />
                <img src={dino?.src} alt="dino" style={{ width: 120, marginBottom: 24 }} />
                <Typography id="login-modal-title" variant="h4" component="h2" sx={{ mb: 2, fontWeight: '550', color: 'white' }}>
                    Hello there
                </Typography>
                <Typography id="login-modal-description" sx={{ mb: 3, color: 'white' }}>
                    Create Account/Sign in to continue to your account
                </Typography>
                <Button
                    variant="outlined"
                    onClick={() => handleGoogleLogin()}
                    sx={{
                        textTransform: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1.5,
                        py: 1.2,
                        borderColor: '#ddd',
                        color: '#555',
                        borderRadius: '100px',
                        background: 'white',
                        fontSize: '16px',
                        '&:hover': {
                            borderColor: '#ccc',
                        },
                    }}
                >
                    <img src={googleIcon} alt="Google" style={{ width: 30, height: 30 }} />
                    Continue with Google
                </Button>
                <Divider sx={{ my: 2 }} />
                <Typography
                    id="login-modal-footer-description"
                    sx={{
                        mb: 3,
                        color: 'white',
                        textAlign: 'center',
                    }}
                >
                    By continuing, you agree to our Terms of Service and <a href="https://datadyno.co/page/datadyno-privacy/" style={{ color: 'white' }}>Privacy Policy</a>.
                </Typography>

            </div>
        </Box>
    </Modal>
}